import {
  Autocomplete,
  Grid,
  TextField,
  FormControl,
  TextFielDecimalNumbers,
  Checkbox,
  FormControlLabel,
  Card,
  CardContent,
  CardHeader,
} from "../../../../components";
import { value } from "../../../../helpers";
import { constantes } from "../resources";

export default function ModeloTributacaoIbs({
  grupoModeloTributacao,
  setGrupoModeloTributacao,
  handleInputChange,
  situacaoIbsList,
  classificacaoIbsList,
  setClassificacaoIbsList,
  buscaClassificacoesIbs,
  codigosCredPres,
  onChangeAutocomplete,
  handleCheckBox,
}) {
  const credPresSelecionado = value.autoComplete(
    codigosCredPres,
    grupoModeloTributacao?.credPresIbsId,
  );

  const limparCredPres = {
    credPresIbsId: null,
    aliquotaCredPresIbs: null,
    aliquotaCredPresCbs: null,
    credPresCondSusIbs: false,
    credPresCondSusCbs: false,
    tpCredPresIbsZfm: null,
  };

  const handleChangeTpCredPresIbsZfm = (e, value) => {
    setGrupoModeloTributacao((prevState) => ({
      ...prevState,
      tpCredPresIbsZfm: value ? value.id : null,
    }));
  };

  const handleChangeSituacaoIbs = (e, value) => {
    onChangeAutocomplete("classificacaoIbsId", null);
    if (value) {
      buscaClassificacoesIbs(value.codigo);
    } else {
      setClassificacaoIbsList([]);
      setGrupoModeloTributacao((prevState) => ({
        ...prevState,
        classificacaoIbsId: null,
        aliquotaIbsUf: null,
        aliquotaIbsMun: null,
        aliquotaCbs: null,
        aliquotaIbsUfRed: null,
        aliquotaIbsMunRed: null,
        aliquotaCbsRed: null,
        ...limparCredPres,
      }));
    }
    onChangeAutocomplete("situacaoIbsId", value);
  };

  const handleChangeClassificacaoIbs = (e, value) => {
    onChangeAutocomplete("classificacaoIbsId", value);
    setGrupoModeloTributacao((prevState) => ({
      ...prevState,
      aliquotaIbsUf: value ? prevState.aliquotaIbsUf : null,
      aliquotaIbsMun: value ? prevState.aliquotaIbsMun : null,
      aliquotaCbs: value ? prevState.aliquotaCbs : null,
      aliquotaIbsUfRed: value?.reducaoIbs,
      aliquotaIbsMunRed: value?.reducaoIbs,
      aliquotaCbsRed: value?.reducaoCbs,
      ...(value ? {} : limparCredPres),
    }));
  };

  const handleChangeCodigoCredPres = (e, value) => {
    onChangeAutocomplete("credPresIbsId", value);
    setGrupoModeloTributacao((prevState) => ({
      ...prevState,
      aliquotaCredPresIbs: value?.indIbs ? prevState.aliquotaCredPresIbs : null,
      aliquotaCredPresCbs: value?.indCbs ? prevState.aliquotaCredPresCbs : null,
      credPresCondSusIbs: value?.indIbs ? prevState.credPresCondSusIbs : false,
      credPresCondSusCbs: value?.indCbs ? prevState.credPresCondSusCbs : false,
    }));
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <FormControl variant="outlined" fullWidth>
            <Autocomplete
              id="situacaoIbsId"
              name="situacaoIbsId"
              options={situacaoIbsList}
              autoHighlight
              getOptionLabel={(option) =>
                option ? `${option?.codigo} - ${option?.descricao}` : ""
              }
              getOptionSelected={(option, value) =>
                option?.descricao === value?.descricao
              }
              noOptionsText="Sem opções"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Situação Tributária IBS/CBS"
                  variant="outlined"
                  margin="normal"
                />
              )}
              onChange={handleChangeSituacaoIbs}
              value={value.autoComplete(
                situacaoIbsList,
                grupoModeloTributacao?.situacaoIbsId,
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={8}>
          <FormControl variant="outlined" fullWidth>
            <Autocomplete
              id="classificacaoIbsId"
              name="classificacaoIbsId"
              options={classificacaoIbsList}
              autoHighlight
              getOptionLabel={(option) =>
                option
                  ? `${option?.codigoClassificacao} - ${option?.nomeClassificacao}`
                  : ""
              }
              getOptionSelected={(option, value) =>
                option?.descricao === value?.descricao
              }
              noOptionsText="Sem opções"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Classificação IBS/CBS"
                  variant="outlined"
                  margin="normal"
                />
              )}
              onChange={handleChangeClassificacaoIbs}
              value={value.autoComplete(
                classificacaoIbsList,
                grupoModeloTributacao?.classificacaoIbsId,
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            id="aliquotaIbsUf"
            name="aliquotaIbsUf"
            label="Alíquota IBS UF"
            margin="normal"
            variant="outlined"
            fullWidth
            value={grupoModeloTributacao?.aliquotaIbsUf ?? ""}
            onBlur={handleInputChange}
          />
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            id="aliquotaIbsMun"
            name="aliquotaIbsMun"
            label="Alíquota IBS Municipal"
            margin="normal"
            variant="outlined"
            fullWidth
            value={grupoModeloTributacao?.aliquotaIbsMun ?? ""}
            onBlur={handleInputChange}
          />
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            id="aliquotaCbs"
            name="aliquotaCbs"
            label="Alíquota CBS"
            margin="normal"
            variant="outlined"
            fullWidth
            value={grupoModeloTributacao?.aliquotaCbs ?? ""}
            onBlur={handleInputChange}
          />
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            id="aliquotaIbsUfRed"
            name="aliquotaIbsUfRed"
            label="Alíquota IBS UF Red."
            margin="normal"
            variant="filled"
            disabled
            fullWidth
            value={grupoModeloTributacao?.aliquotaIbsUfRed ?? ""}
            onBlur={handleInputChange}
          />
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            id="aliquotaIbsMunRed"
            name="aliquotaIbsMunRed"
            label="Alíquota IBS Municipal Red."
            margin="normal"
            variant="filled"
            disabled
            fullWidth
            value={grupoModeloTributacao?.aliquotaIbsMunRed ?? ""}
            onBlur={handleInputChange}
          />
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            id="aliquotaCbsRed"
            name="aliquotaCbsRed"
            label="Alíquota CBS Red."
            margin="normal"
            variant="filled"
            disabled
            fullWidth
            value={grupoModeloTributacao?.aliquotaCbsRed ?? ""}
            onBlur={handleInputChange}
          />
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            id="aliquotaDeferimentoUfIbs"
            name="aliquotaDeferimentoUfIbs"
            label="Alíquota Deferimento UF"
            margin="normal"
            variant={
              [97, 98].includes(grupoModeloTributacao?.situacaoIbsId)
                ? "outlined"
                : "filled"
            }
            disabled={![97, 98].includes(grupoModeloTributacao?.situacaoIbsId)}
            fullWidth
            value={grupoModeloTributacao?.aliquotaDeferimentoUfIbs ?? ""}
            onBlur={handleInputChange}
          />
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            id="aliquotaDeferimentoMunIbs"
            name="aliquotaDeferimentoMunIbs"
            label="Alíquota Deferimento Mun."
            margin="normal"
            variant={
              [97, 98].includes(grupoModeloTributacao?.situacaoIbsId)
                ? "outlined"
                : "filled"
            }
            disabled={![97, 98].includes(grupoModeloTributacao?.situacaoIbsId)}
            fullWidth
            value={grupoModeloTributacao?.aliquotaDeferimentoMunIbs ?? ""}
            onBlur={handleInputChange}
          />
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            id="aliquotaDeferimentoCbs"
            name="aliquotaDeferimentoCbs"
            label="Alíquota Deferimento CBS"
            margin="normal"
            variant={
              [97, 98].includes(grupoModeloTributacao?.situacaoIbsId)
                ? "outlined"
                : "filled"
            }
            disabled={![97, 98].includes(grupoModeloTributacao?.situacaoIbsId)}
            fullWidth
            value={grupoModeloTributacao?.aliquotaDeferimentoCbs ?? ""}
            onBlur={handleInputChange}
          />
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            id="aliquotaIbsUfGov"
            name="aliquotaIbsUfGov"
            label="Alíquota IBS UF (Governamental)"
            margin="normal"
            fullWidth
            disabled={!grupoModeloTributacao?.aliquotaIbsUfRed}
            variant={
              grupoModeloTributacao?.aliquotaIbsUfRed ? "outlined" : "filled"
            }
            value={grupoModeloTributacao?.aliquotaIbsUfGov ?? ""}
            onBlur={handleInputChange}
          />
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            id="aliquotaIbsMunGov"
            name="aliquotaIbsMunGov"
            label="Alíquota IBS Municipal (Governamental)"
            margin="normal"
            fullWidth
            disabled={!grupoModeloTributacao?.aliquotaIbsUfRed}
            variant={
              grupoModeloTributacao?.aliquotaIbsUfRed ? "outlined" : "filled"
            }
            value={grupoModeloTributacao?.aliquotaIbsMunGov ?? ""}
            onBlur={handleInputChange}
          />
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            id="aliquotaCbsGov"
            name="aliquotaCbsGov"
            label="Alíquota CBS (Governamental)"
            margin="normal"
            fullWidth
            disabled={!grupoModeloTributacao?.aliquotaIbsUfRed}
            variant={
              grupoModeloTributacao?.aliquotaIbsUfRed ? "outlined" : "filled"
            }
            value={grupoModeloTributacao?.aliquotaCbsGov ?? ""}
            onBlur={handleInputChange}
          />
        </Grid>
        {grupoModeloTributacao?.classificacaoIbsId && (
          <Grid item xs={6}>
            <FormControl variant="outlined" fullWidth>
              <Autocomplete
                id="credPresIbsId"
                name="credPresIbsId"
                options={codigosCredPres}
                autoHighlight
                getOptionLabel={(option) =>
                  option ? `${option?.codigo} - ${option?.descricao}` : ""
                }
                getOptionSelected={(option, value) =>
                  option?.descricao === value?.descricao
                }
                noOptionsText="Sem opções"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Modalidade de Crédito Presumido"
                    variant="outlined"
                    margin="normal"
                  />
                )}
                onChange={handleChangeCodigoCredPres}
                value={credPresSelecionado}
              />
            </FormControl>
          </Grid>
        )}
        {grupoModeloTributacao?.classificacaoIbsId && (
          <Grid item xs={6}>
            <FormControl variant="outlined" fullWidth>
              <Autocomplete
                id="tpCredPresIbsZfm"
                name="tpCredPresIbsZfm"
                options={constantes?.classificacoesCredPresIbsZfm}
                autoHighlight
                getOptionLabel={(option) =>
                  option ? `${option?.codigo} - ${option?.descricao}` : ""
                }
                getOptionSelected={(option, value) =>
                  option?.codigo === value?.codigo
                }
                noOptionsText="Sem opções"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Class. para subapuração do IBS na ZFM"
                    variant="outlined"
                    margin="normal"
                  />
                )}
                onChange={handleChangeTpCredPresIbsZfm}
                value={
                  constantes?.classificacoesCredPresIbsZfm.find(
                    ({ id }) => id === grupoModeloTributacao?.tpCredPresIbsZfm,
                  ) ?? null
                }
              />
            </FormControl>
          </Grid>
        )}
        {credPresSelecionado?.indIbs && (
          <Grid item xs={6}>
            <CredPresCard
              titulo="Crédito Presumido - IBS"
              campoAliquota="aliquotaCredPresIbs"
              campoCondSus="credPresCondSusIbs"
              grupoModeloTributacao={grupoModeloTributacao}
              handleInputChange={handleInputChange}
              handleCheckBox={handleCheckBox}
            />
          </Grid>
        )}
        {credPresSelecionado?.indCbs && (
          <Grid item xs={6}>
            <CredPresCard
              titulo="Crédito Presumido - CBS"
              campoAliquota="aliquotaCredPresCbs"
              campoCondSus="credPresCondSusCbs"
              grupoModeloTributacao={grupoModeloTributacao}
              handleInputChange={handleInputChange}
              handleCheckBox={handleCheckBox}
            />
          </Grid>
        )}
      </Grid>
      <Grid container spacing={2} className="mt-1">
        <Grid item xs={2} className="d-flex align-items-center">
          <FormControlLabel
            control={
              <Checkbox
                checked={grupoModeloTributacao?.descontoIbsBase ?? false}
                onClick={handleCheckBox}
                color="primary"
                value={grupoModeloTributacao?.descontoIbsBase}
                name="descontoIbsBase"
              />
            }
            label="Desconto na base"
          />
        </Grid>
        <Grid item xs={2} className="d-flex align-items-center">
          <FormControlLabel
            control={
              <Checkbox
                checked={grupoModeloTributacao?.despesaIbsBase ?? false}
                onClick={handleCheckBox}
                color="primary"
                value={grupoModeloTributacao?.despesaIbsBase}
                name="despesaIbsBase"
              />
            }
            label="Despesa na base"
          />
        </Grid>
        <Grid item xs={2} className="d-flex align-items-center">
          <FormControlLabel
            control={
              <Checkbox
                checked={grupoModeloTributacao?.ipiIbsBase ?? false}
                onClick={handleCheckBox}
                color="primary"
                value={grupoModeloTributacao?.ipiIbsBase}
                name="ipiIbsBase"
              />
            }
            label="IPI na base"
          />
        </Grid>
        <Grid item xs={2} className="d-flex align-items-center">
          <FormControlLabel
            control={
              <Checkbox
                checked={grupoModeloTributacao?.freteIbsBase ?? false}
                onClick={handleCheckBox}
                color="primary"
                value={grupoModeloTributacao?.freteIbsBase}
                name="freteIbsBase"
              />
            }
            label="Frete na base"
          />
        </Grid>
        <Grid item xs={2} className="d-flex align-items-center">
          <FormControlLabel
            control={
              <Checkbox
                checked={grupoModeloTributacao?.seguroIbsBase ?? false}
                onClick={handleCheckBox}
                color="primary"
                value={grupoModeloTributacao?.seguroIbsBase}
                name="seguroIbsBase"
              />
            }
            label="Seguro na base"
          />
        </Grid>
      </Grid>
    </>
  );
}

function CredPresCard({
  titulo,
  campoAliquota,
  campoCondSus,
  grupoModeloTributacao,
  handleInputChange,
  handleCheckBox,
}) {
  return (
    <Card
      variant="outlined"
      sx={{
        margin: 0,
        padding: 0,
        borderRadius: 1,
        boxShadow: "none",
        border: "1px solid #e0e0e0",
      }}
    >
      <CardContent sx={{ margin: 0 }}>
        <CardHeader title={titulo} sx={{ margin: 0, padding: 0 }} />
        <TextFielDecimalNumbers
          id={campoAliquota}
          name={campoAliquota}
          label="Percentual do Crédito Presumido (%)"
          margin="normal"
          variant="outlined"
          fullWidth
          value={grupoModeloTributacao?.[campoAliquota] ?? ""}
          onBlur={handleInputChange}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={grupoModeloTributacao?.[campoCondSus] ?? false}
              onClick={handleCheckBox}
              color="primary"
              value={grupoModeloTributacao?.[campoCondSus]}
              name={campoCondSus}
            />
          }
          label="Crédito em condição suspensiva"
        />
      </CardContent>
    </Card>
  );
}
